import { Fragment, useEffect, useRef, useState } from "react";
import { useHistory, Link } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import AsyncFilter from "src/components/common/frame/asyncFilter";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, 
    scroll, 
    boolAndReducer, 
    getTimeStamp, 
    isDevMode, 
    appTitle, 
} from "src/components/common/functions";
import Detail from "./detail";
import Export from "./export";
import ContactForm from "./contactForm";
//--------------------------------------------------------------------------------------------
export default function Contacts({ tabTitle }){
    const width = "40rem";
    const url = "contacts/readContacts.php";
    const dataFrame = [
        {label: "First Name", key: "firstName"}, 
        {label: "Last Name", key: "lastName"}, 
        {label: "Email 1", key: "contactEmail"}, 
        {label: "Email 2", key: "contactEmail2"}, 
        {label: "Role", key: "role"}, 
        {label: "Business Phone", key : "businessPhone"}, 
        {label: "Direct Number", key : "directNumber"}, 
        {label: "Mobile", key : "mobile"}, 
        {label: "Fax", key : "fax"}, 
        {label: "Street", key: "street"}, 
        {label: "City", key: "city"}, 
        {label: "State", key: "state"}, 
        {label: "Postal Code", key: "postalCode"}, 
        {label: "Country", key: "country"}, 
        {label: "Background", key: "background"}, 
    ];
    const defaultFilter = Object.fromEntries(dataFrame.map(item => [item.key, ""]));
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const user = useMyStore(state => state.user);
    const contacts = useMyStore(state => state.contacts);
    const setContacts = useMyStore(state => state.setContacts);
    const contactDetails = useMyStore(state => state.contactDetails);
    const organizationNames = useMyStore(state => state.organizationNames);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? ""); // title
    const path2 = decodeURIComponent(path.split("/")[2] ?? ""); // hash | "Add"
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Contacts": contacts.updatedAt === null?getTimeStamp():contacts.updatedAt, 
        "ContactDetails": contactDetails.updatedAt === null?getTimeStamp():contactDetails.updatedAt, 
        "OrganizationNames": organizationNames.updatedAt === null?getTimeStamp():organizationNames.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showFloatingContact, setShowFloatingContact] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [curFilter, setFilter] = useState(defaultFilter);
    const [activeFilter, setActiveFilter] = useState(defaultFilter);
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //--------------------------------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredContacts = contacts.data.filter(u => 
        (showFloatingContact?u.organizationHashKey === null:true)
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true)) 
    );
    const currentPageItems = filteredContacts.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredContacts.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    const prevDependencies = useRef({ path1, path2 });
    useEffect(() => {
        if(updateDateTime["Contacts"] === contacts.updatedAt) return;
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            if(isDevMode) console.log("useEffect");
            //--------------------------------------------------------
            setShowLoading(true);
            const res = await myAxios("contacts/readContacts.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //--------------------------------------------------------
            setContacts(res.data, updateDateTime["Contacts"]);
            if(!res.data.find(u => path2 === u.contactHashKey)){
                switch(path2){
                    case "Add":
                        return;
                    case undefined:
                        return
                    default:
                }
                history.replace(`/${path1}`);
                return;
            }
        }
        getData();
        prevDependencies.current = { path1, path2 };
        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [history, updateDateTime, path1, path2, setContacts, contacts.updatedAt])
    useEffect(() => {
        if(path2 !== "" && path2 !== "Add"){
            const hashkeys = filteredContacts.map(v => v.contactHashKey);
            setCurrentPage(Math.ceil((hashkeys.indexOf(path2) + 1) / itemsPerPage));
            scroll(path2);
        }
    }, [path2, itemsPerPage, filteredContacts, history])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <button
                        type = "button"
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary ml-3"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >↻</button>
                </span>
                <span>
                    <input
                        id = "searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "noOrg">No Org {tabTitle}</label>
                    <input
                        id = "noOrg"
                        type = "checkbox"
                        className = "cssCheckBox ml-2"
                        onChange = {e => {
                            setShowFloatingContact(e.currentTarget.checked);
                            setCurrentPage(1);
                        }}
                    />
                </span>
                <AsyncFilter
                    setCurrentPage = {setCurrentPage}
                    setFilter = {setFilter}
                    setActiveFilter = {setActiveFilter}
                    curFilter = {curFilter}
                    activeFilter = {activeFilter}
                    defaultFilter = {defaultFilter}
                    width = {width}
                    url = {url}
                    dataFrame = {dataFrame}
                    setItems = {useMyStore(state => state.setContacts)}
                />
                <Export
                    filteredContacts = {filteredContacts}
                />
                <button type = "button" className = "headerButton" onClick = {() => history.push(`/${path1}/Add`)}>Add</button>
                {path2 === "Add"?
                <ContactForm
                    updateDateTime = {updateDateTime}
                    closeIt = {() => history.push(`/${path1}`)}
                    history = {history}
                    keyword = "Add"
                />
                :null}
            </div>
            <div className = {"cssContent" + (!showLoading && filteredContacts.length?" pb10":"")}>
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filteredContacts.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Email 1</th>
                            <th>Email 2</th>
                            <th>Role</th>
                            <th>Organization Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentPageItems.map((contact, key) => 
                        <Fragment key = {key}>
                        <tr>
                            <td>
                                <button
                                    type = "button"
                                    className = {(path2 === contact.contactHashKey?"showMinus":"showPlus") + " childRow"}
                                    id = {contact.contactHashKey}
                                    onClick = {async e => {
                                        if(path2 !== e.currentTarget.id){
                                            history.push(`/${path1}/${e.currentTarget.id}`);
                                            scroll(e.currentTarget.id);
                                        }else{
                                            history.push(`/${path1}`);
                                            scroll(null);
                                        }
                                    }}
                                />
                            </td>
                            <td>{contact.contactName}</td>
                            <td>{contact.contactEmail?<a href = {`mailto:${contact.contactEmail}`}>{contact.contactEmail}</a>:<></>}</td>
                            <td>{contact.contactEmail2?<a href = {`mailto:${contact.contactEmail2}`}>{contact.contactEmail2}</a>:<></>}</td>
                            <td>{contact.role}</td>
                            <td>{contact.organizationHashKey?<Link to = {`/Organizations/${contact.organizationHashKey}`}>{contact.organizationName}</Link>:<></>}</td>
                        </tr>
                        <tr>
                            <td className = "noborder" colSpan = {100}>
                                <TransitionWidthHeight
                                    classNames = "cssTDTransition"
                                    In = {path2 ===  contact.contactHashKey}
                                >
                                    <Detail
                                        updateDateTime = {updateDateTime}
                                        contact = {contact}
                                        history = {history}
                                        setCurrentPage = {setCurrentPage}
                                    />
                                </TransitionWidthHeight>
                            </td>
                        </tr>
                        </Fragment>)}
                    </tbody>
                </table>
                </div>}
                {!showLoading && filteredContacts.length?
                <Footer
                    length = {filteredContacts.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}

                    paginateAction = {() => history.push(`/${path1}`)}
                />
                :null}
            </div>
        </div>
    )
}